import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Minus = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.55071 8.33838C3.55071 8.06224 3.77457 7.83838 4.05071 7.83838L12.8354 7.83838C13.1116 7.83838 13.3354 8.06224 13.3354 8.33838C13.3354 8.61452 13.1116 8.83838 12.8354 8.83838L4.05071 8.83838C3.77457 8.83838 3.55071 8.61452 3.55071 8.33838Z"
        fill={color}
      />
    </svg>
  )
})

export default Minus
